import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.regexp.replace";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import listMixin from '../listMixin';
import { mapState } from 'vuex';
import { userItemsPerListMixin } from '@/utils/vuex';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'NiotaClassicDatasourcesList',
  mixins: [listMixin, userItemsPerListMixin],
  props: {},
  data: function data() {
    return {
      tableOptions: {
        sortBy: ['source'],
        sortDesc: [false],
        itemsPerPage: defaultItemsPerPage
      },
      disableFetchOnCreatedMixin: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    tableLocalizations: function tableLocalizations() {
      return {
        headers: [{
          text: this.$i18n_t('NiotaClassic.Common.table.id'),
          value: 'id',
          align: 'right'
        }, {
          sortable: false
        }, {
          text: this.$i18n_t('NiotaClassic.DataSources.table.source'),
          value: 'source',
          align: 'start'
        }, {
          text: this.$i18n_t('NiotaClassic.DataSources.table.type'),
          value: 'type',
          align: 'start'
        }, {
          text: this.$i18n_t('NiotaClassic.DataSources.table.status'),
          value: 'status',
          sortable: false
        }, {
          text: this.$i18n_t('NiotaClassic.DataSources.table.active'),
          value: 'active',
          align: 'center',
          sortable: false
        }, {
          text: this.$i18n_t('NiotaClassic.Common.table.createdAt'),
          value: 'createdAt'
        }, {
          sortable: false
        }],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
        }
      };
    }
  }),
  created: function created() {
    this.tableOptions.itemsPerPage = this.savedUserItemsPerList();
  },
  methods: {
    updatePagination: function updatePagination(e) {
      this.$router.replace({
        query: _objectSpread(_objectSpread(_objectSpread({}, this.$route.query), {
          page: e.page || defaultTableOptions.page
        }), {
          perPage: e.itemsPerPage || defaultTableOptions.itemsPerPage
        })
      }).catch(function (error) {
        console.error(error);
      });
    },
    fetchList: function fetchList() {
      var _this = this;

      if (this.isFetching) {
        return;
      }

      this.isFetching = true;
      var _this$tableOptions = this.tableOptions,
          sortBy = _this$tableOptions.sortBy,
          sortDesc = _this$tableOptions.sortDesc,
          page = _this$tableOptions.page,
          itemsPerPage = _this$tableOptions.itemsPerPage;
      var sortItem = sortBy && sortBy.length ? sortBy[0] : 'createdAt';
      var doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : true;
      var sortDirection = doSortDesc ? 'DESC' : 'ASC';
      var usedPage = Math.max(1, page || 1);
      var usedItemsPerPage = itemsPerPage || defaultItemsPerPage;
      NiotaClassicApiService.dataSourcesFetch((this.searchItem || '').trim(), usedPage, usedItemsPerPage, sortItem, sortDirection).then(function (res) {
        _this.list = res.data.datasources;
        _this.serverItemsLength = res.pagination.itemCount;
      }).catch(function (error) {
        console.error('Error fetching datasources', error);
      }).finally(function () {
        _this.isFetching = false;
      });
    },
    deletePromise: function deletePromise() {
      return NiotaClassicApiService.dataSourcesDelete(this.selectedItem.id);
    }
  }
};